import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class FrontendSecurity extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Security</title>
                    <meta name="description" content="Security" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Frontend"  breadcrumb_2="Security" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Security</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                            <h4>Lock the front door.</h4>
                            <p className="text-sm">
                               Security on the front end boils down to two major things:

                            </p>
                            <ol>
                                <li  className="text-sm">Dont console.log or show the end user any sensitive data</li>
                                <li  className="text-sm">Never ever ever add in a secret key on the frontend. This must be handled by our projects server.</li>
                            </ol>
                            <p className="text-sm">Simple rules to follow and if you ever feel you are violating one don't hesitate to ask! <b>There are no stupid question in the world of security.</b></p>

                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default FrontendSecurity